/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as TokensIndexRouteImport } from './routes/tokens/index'
import { Route as RpcIndexRouteImport } from './routes/rpc/index'
import { Route as HistoryIndexRouteImport } from './routes/history/index'
import { Route as GrpcIndexRouteImport } from './routes/grpc/index'
import { Route as TokensMintRouteImport } from './routes/tokens/$mint'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => rootRouteImport,
} as any)
const TokensIndexRoute = TokensIndexRouteImport.update({
  id: '/tokens/',
  path: '/tokens/',
  getParentRoute: () => rootRouteImport,
} as any)
const RpcIndexRoute = RpcIndexRouteImport.update({
  id: '/rpc/',
  path: '/rpc/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const GrpcIndexRoute = GrpcIndexRouteImport.update({
  id: '/grpc/',
  path: '/grpc/',
  getParentRoute: () => rootRouteImport,
} as any)
const TokensMintRoute = TokensMintRouteImport.update({
  id: '/tokens/$mint',
  path: '/tokens/$mint',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/tokens/$mint': typeof TokensMintRoute
  '/grpc': typeof GrpcIndexRoute
  '/history': typeof HistoryIndexRoute
  '/rpc': typeof RpcIndexRoute
  '/tokens': typeof TokensIndexRoute
  '/transactions': typeof TransactionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/tokens/$mint': typeof TokensMintRoute
  '/grpc': typeof GrpcIndexRoute
  '/history': typeof HistoryIndexRoute
  '/rpc': typeof RpcIndexRoute
  '/tokens': typeof TokensIndexRoute
  '/transactions': typeof TransactionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/tokens/$mint': typeof TokensMintRoute
  '/grpc/': typeof GrpcIndexRoute
  '/history/': typeof HistoryIndexRoute
  '/rpc/': typeof RpcIndexRoute
  '/tokens/': typeof TokensIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/tokens/$mint'
    | '/grpc'
    | '/history'
    | '/rpc'
    | '/tokens'
    | '/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/tokens/$mint'
    | '/grpc'
    | '/history'
    | '/rpc'
    | '/tokens'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/tokens/$mint'
    | '/grpc/'
    | '/history/'
    | '/rpc/'
    | '/tokens/'
    | '/transactions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  TokensMintRoute: typeof TokensMintRoute
  GrpcIndexRoute: typeof GrpcIndexRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  RpcIndexRoute: typeof RpcIndexRoute
  TokensIndexRoute: typeof TokensIndexRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokens/': {
      id: '/tokens/'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof TokensIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rpc/': {
      id: '/rpc/'
      path: '/rpc'
      fullPath: '/rpc'
      preLoaderRoute: typeof RpcIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grpc/': {
      id: '/grpc/'
      path: '/grpc'
      fullPath: '/grpc'
      preLoaderRoute: typeof GrpcIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokens/$mint': {
      id: '/tokens/$mint'
      path: '/tokens/$mint'
      fullPath: '/tokens/$mint'
      preLoaderRoute: typeof TokensMintRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  TokensMintRoute: TokensMintRoute,
  GrpcIndexRoute: GrpcIndexRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  RpcIndexRoute: RpcIndexRoute,
  TokensIndexRoute: TokensIndexRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
